import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { ProviderService } from '../../api';
import { SessionContext } from '../contexts/SessionContext';
import { providerQueryKeys } from '../query-keys-factories/providers';

export const useCanShowReferralButton = () => {
  const { user, audienceIsProvider } = useContext(SessionContext);
  const { data: currentProvider } = useQuery({
    queryKey: providerQueryKeys.currentDetail(),
    queryFn: () => ProviderService.providerCurrentRetrieve(),
    enabled: !!audienceIsProvider && !!user,
  });
  return (
    !!audienceIsProvider &&
    process.env.REACT_APP_PROV_REFERRAL_PROGRAM_ACTIVE === 'true' &&
    !!currentProvider?.referral_url
  );
};

export const useProvider = () => {
  const { providerId } = useParams();

  const {
    isLoading: isCurrentProviderLoading,
    error: currentProviderFetchError,
    data: currentProvider,
  } = useQuery({
    queryKey: providerQueryKeys.currentDetail(),
    queryFn: async () => await ProviderService.providerCurrentRetrieve(),
    enabled: !providerId,
  });

  const {
    isLoading: isURLProviderLoading,
    error: urlProviderFetchError,
    data: urlProvider,
  } = useQuery({
    queryKey: providerQueryKeys.detail(providerId as string),
    queryFn: async () =>
      await ProviderService.providerRetrieve({ providerId: providerId as string }),
    enabled: !!providerId,
  });

  const provider = !providerId ? currentProvider : urlProvider;
  const isProviderLoading = !providerId ? isCurrentProviderLoading : isURLProviderLoading;
  const providerFetchError = !providerId ? currentProviderFetchError : urlProviderFetchError;

  return {
    provider,
    isProviderLoading,
    providerFetchError,
  };
};

export const useProviderId = () => {
  const { providerId } = useParams();
  const { user } = useContext(SessionContext);

  return providerId ?? user?.provider_id;
};
